import type { Axios } from "axios";

import { getAuthToken } from "@skilitics/designer-auth/state";

export const attachAuthorizationMiddleware = (axios: Axios) => {
  axios.interceptors.request.use(async (config) => {
    config.headers["x-skilitics-token"] = await getAuthToken();
    return config;
  });
};
